import { useState } from 'react';
import { selectionProcessesAdmin } from '@/services/selectionProcesses';

function downloadBlob(response, fallbackName) {
  const blob = response.data;
  const dispo = response.headers?.['content-disposition'] || '';
  const m = dispo.match(/filename="([^"]+)"/);
  const name = m ? m[1] : fallbackName;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}

export default function ExportButtons({ processId, slug, filters }) {
  const [downloading, setDownloading] = useState(null);

  const handle = async kind => {
    if (downloading) return;
    setDownloading(kind);
    try {
      const fn = kind === 'csv' ? selectionProcessesAdmin.exportCsv : selectionProcessesAdmin.exportXlsx;
      const ext = kind === 'csv' ? 'csv' : 'xlsx';
      const res = await fn(processId, filters);
      downloadBlob(res, `inscritos-${slug}.${ext}`);
    } finally {
      setDownloading(null);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn--outline btn--small"
        disabled={!!downloading}
        onClick={() => handle('csv')}
      >
        {downloading === 'csv' ? 'Exportando…' : 'CSV'}
      </button>
      <button
        type="button"
        className="btn btn--outline btn--small"
        disabled={!!downloading}
        onClick={() => handle('xlsx')}
      >
        {downloading === 'xlsx' ? 'Exportando…' : 'Planilha (XLSX)'}
      </button>
    </>
  );
}
